var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16797 1.64453L27.543 14.707C28.582 15.375 29.25 16.5625 29.25 17.75C29.25 19.0117 28.582 20.1992 27.543 20.793L6.16797 33.8555C5.05469 34.5234 3.64453 34.5977 2.53125 33.9297C1.41797 33.3359 0.75 32.1484 0.75 30.8125V4.6875C0.75 3.42578 1.41797 2.23828 2.53125 1.64453C3.64453 0.976562 5.05469 0.976562 6.16797 1.64453Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBig);
export default __webpack_public_path__ + "static/media/play-big.60ae064b64f0e9c69372948fd00cd095.svg";
export { ForwardRef as ReactComponent };